export class Color {
    red: number;
    green: number;
    blue: number;
    alpha?: number;
    hex: string;

    constructor(hex: string, red: number, green: number, blue: number, alpha?: number) {
        this.hex = hex;
        this.red = red;
        this.green = green;
        this.blue = blue;
        this.alpha = alpha;
    }

    toString(): string {
        if (this.alpha) {
            return `rgba(${this.red},${this.green},${this.blue},${this.alpha})`;
        }
        return this.hex;
    }

    transformOpacity(alpha: number): string {
        if (this.alpha) {
            throw new Error('Alpha blending is not supported. Color already has opacity set.');
        }
        return `rgba(${this.red},${this.green},${this.blue},${alpha})`;
    }
}
